<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="form.preAgendamentos"
            ref="Table"
            sort-by="data"
            :sort-compare="sortCompare"
        >

            <template v-slot:cell(checkbox)="{ item }">
                <rkm-form-radio
                    v-model="item.selecionado"
                    name="selecionado"
                    :value="true"
                    inline
                    @click.stop="handleSelecionado(item)"
                />
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Moment
import moment from "moment";

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

export default {
    computed: {
        fields() {

            const fields = [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: 'data',
                    label: 'Data',
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: 'horario',
                    label: 'Horário',
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: 'municipio',
                    label: 'Município ',
                    sortable: true
                },
                {
                    key: 'transportePacienteDestino',
                    label: 'Destino',
                    sortable: true
                },
                {
                    key: 'transportePacienteMotivo',
                    label: 'Motivo',
                    sortable: true
                },
            ]

            return fields
        },
    },
    data: () => ({
        repositories: {
            agendar: null,
        },
        items: [],
        data: null,
        total: null,
    }),
    methods: {
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        handleSelecionado({ index }) {

            this.form.preAgendamentos.map((_, i) => i !== index && (this.form.preAgendamentos[i].selecionado = false))
            this.form.preAgendamentos.map((_, i) => i == index && (this.telefones[i].selecionado = true))
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        form: { type: Object, default: null },
    },
}
</script>

<style scoped>
.row {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border: 1px solid #dee2e6;
    margin: 0;
}
.total {float:left; width: 54%}
</style>